import { useMsal } from '@azure/msal-react'
import { useTheme } from '../context/ThemeContext'

function Layout({ children }) {
    const { instance, accounts } = useMsal()
    const { theme, toggleTheme } = useTheme()
    const activeAccount = accounts[0]

    const handleLogout = () => {
        instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin,
        })
    }

    return (
        <div className={`min-h-screen ${theme === 'dark' ? 'bg-slate-950' : 'bg-gray-50'}`}>
            {/* Header */}
            <header className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 shadow-2xl border-b-4 border-blue-600">
                <div className="max-w-[1980px] mx-auto px-4 sm:px-6 lg:px-10 2xl:px-14">
                    <div className="flex justify-between items-center h-14 sm:h-20">
                        {/* Logo / Brand */}
                        <div className="flex items-center space-x-3 sm:space-x-4 min-w-0">
                            <div className="flex-shrink-0">
                                <img
                                    src="/aviator-energy-design.png"
                                    alt="Aviator Energy"
                                    className="h-10 sm:h-16 w-auto"
                                />
                            </div>
                            <div className="border-l-2 border-blue-400 pl-3 sm:pl-4 min-w-0">
                                <h1 className="text-base sm:text-xl font-bold text-white tracking-wide">Daily Dashboard</h1>
                                <p className="text-[10px] sm:text-xs text-blue-200 hidden sm:block">Operations Analytics</p>
                            </div>
                        </div>

                        {/* User Menu */}
                        <div className="flex items-center space-x-2 sm:space-x-4 flex-shrink-0">
                            <button
                                onClick={toggleTheme}
                                className="text-white hover:text-blue-200 transition p-1.5 sm:p-2 rounded-lg hover:bg-blue-800"
                                title={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
                            >
                                {theme === 'dark' ? (
                                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                                    </svg>
                                ) : (
                                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                                    </svg>
                                )}
                            </button>

                            <span className="text-sm text-blue-100 font-medium hidden md:inline">
                                {activeAccount?.username || 'User'}
                            </span>
                            <button
                                onClick={handleLogout}
                                className="text-xs sm:text-sm text-white bg-blue-700 hover:bg-blue-600 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg font-medium transition shadow-md"
                            >
                                Sign Out
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            {/* Main Content */}
            <main className="max-w-[1980px] mx-auto px-4 sm:px-6 lg:px-10 2xl:px-14 py-8">
                {children}
            </main>

            {/* Footer */}
            <footer className={`${theme === 'dark' ? 'bg-slate-950 border-slate-900' : 'bg-gray-100 border-gray-300'} border-t mt-auto`}>
                <div className="max-w-[1980px] mx-auto px-4 sm:px-6 lg:px-10 2xl:px-14 py-4">
                    <p className={`text-center text-sm ${theme === 'dark' ? 'text-gray-500' : 'text-gray-600'}`}>
                        &copy; {new Date().getFullYear()} Aviator Energy. Internal Use Only.
                    </p>
                </div>
            </footer>
        </div>
    )
}

export default Layout
